import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const TeamIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g clipPath="url(#clip0_1158_39156)">
      <g opacity="0.3">
        <path
          d="M8.06982 16C8.15982 15.77 8.19982 15.61 8.97982 15.31C9.94982 14.93 10.9698 14.75 11.9998 14.75C13.0298 14.75 14.0498 14.93 15.0198 15.31C15.7898 15.61 15.8298 15.77 15.9298 16H8.06982ZM11.9998 8C12.5498 8 12.9998 8.45 12.9998 9C12.9998 9.55 12.5498 10 11.9998 10C11.4498 10 10.9998 9.55 10.9998 9C10.9998 8.45 11.4498 8 11.9998 8Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.2 15.61 8.98 15.31C9.95 14.93 10.97 14.75 12 14.75C13.03 14.75 14.05 14.93 15.02 15.31C15.79 15.61 15.83 15.77 15.93 16H8.07ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1158_39156">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default TeamIcon;
